module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAYAAAA6oTAqAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAExSURBVHgB7ZjNbYNAEIVnFwpIKS6BnBCckkpSgpUSUklyAnGjBEpJA4BnLFuy5L+19BBj630nJFaCTwOrfS/IArRtW2RZtp3nubhwexjH8buu6z8BEwRM0zQfKvJ7b900Te9VVfUCJAqYPM+/UtaFELYCBi5z5dM6Q2U2AgYu8wBvAmZNGTiU8QplvEIZr1DGK5TxCmW8Qhmv7GPzMbPr5UbDFTxnLIm+b68R/Mc6hZCa2b1jnULUzA7P4mtgnULUMcGz+BqoTMHdzCuU8UrUH6eX12CIVmLLC2Ae8VBefz7jhPSd/+0EYNvy/gQgYLqum1PXlmUJfT53M69QxiuU8QplvEIZr1DGK5TxCmVuYYFJVmKJyQwpiywhChi4TGqnYGW3gIHLHDsFuTKh08wuYHZOMV1BqHLuOQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/blackPlus@3x.png
// module id = 1829
// module chunks = 0